import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { to: '/westminster-homes-for-sale', label: 'Westminster Homes' },
  { to: '/little-saigon-real-estate', label: 'Little Saigon' },
  { to: '/garden-grove-vietnamese-homes', label: 'Garden Grove' },
  { to: '/fountain-valley-real-estate', label: 'Fountain Valley' },
  { to: '/midway-city-homes-for-sale', label: 'Midway City' },
  { to: '/westminster-pho-district-homes', label: 'Pho District' },
  { to: '/bolsa-avenue-corridor-real-estate', label: 'Bolsa Avenue' },
  { to: '/vietnamese-owned-homes-westminster', label: 'Vietnamese Homes Westminster' },
  { to: '/westminster-first-time-homebuyers', label: 'First Time Buyers' },
  { to: '/westminster-luxury-homes', label: 'Luxury Homes' },
  { to: '/sell-your-home-westminster', label: 'Sell Your Home' },
  { to: '/westminster-investment-properties', label: 'Investment Properties' },
  { to: '/vietnamese-community-homes-orange-county', label: 'Vietnamese Community OC' },
  { to: '/westminster-condos-for-sale', label: 'Condos' },
  { to: '/stanton-homes-near-westminster', label: 'Stanton' },
  { to: '/westminster-townhomes', label: 'Townhomes' },
  { to: '/huntington-beach-vietnamese-community-homes', label: 'Huntington Beach' },
  { to: '/westminster-new-construction', label: 'New Construction' },
  { to: '/westminster-home-value-estimate', label: 'Home Value Estimate' },
  { to: '/santa-ana-vietnamese-market-real-estate', label: 'Santa Ana' },
{ to: '/el-monte-vietnamese-homes', label: 'El Monte' },
  { to: '/rosemead-vietnamese-real-estate', label: 'Rosemead' },
  { to: '/san-gabriel-valley-vietnamese-homes', label: 'San Gabriel Valley' },
  { to: '/alhambra-vietnamese-community-homes', label: 'Alhambra' },
  { to: '/monterey-park-homes-for-sale', label: 'Monterey Park' },
  { to: '/temple-city-vietnamese-homes', label: 'Temple City' },
  { to: '/baldwin-park-vietnamese-homes', label: 'Baldwin Park' },
  { to: '/west-covina-vietnamese-homes', label: 'West Covina' },
  { to: '/pomona-vietnamese-community-homes', label: 'Pomona' },
  { to: '/diamond-bar-homes-for-sale', label: 'Diamond Bar' },
  { to: '/long-beach-vietnamese-community-homes', label: 'Long Beach' },
  { to: '/los-angeles-vietnamese-community-real-estate', label: 'LA Vietnamese' },
  { to: '/south-el-monte-homes-for-sale', label: 'South El Monte' },
  { to: '/hacienda-heights-asian-community-homes', label: 'Hacienda Heights' },
  { to: '/rowland-heights-asian-community-homes', label: 'Rowland Heights' },
  { to: '/montebello-vietnamese-homes', label: 'Montebello' },
  { to: '/covina-homes-for-sale', label: 'Covina' },
  { to: '/arcadia-asian-community-homes', label: 'Arcadia' },
  { to: '/walnut-homes-for-sale', label: 'Walnut' },
  { to: '/la-puente-vietnamese-homes', label: 'La Puente' },
  { to: '/anaheim-vietnamese-homes-for-sale', label: 'Anaheim' },
  { to: '/buena-park-vietnamese-community-homes', label: 'Buena Park' },
  { to: '/cypress-homes-near-little-saigon', label: 'Cypress' },
  { to: '/la-palma-homes-for-sale', label: 'La Palma' },
  { to: '/tustin-vietnamese-community-real-estate', label: 'Tustin' },
  { to: '/vietnamese-speaking-realtor-los-angeles', label: 'VN Realtor LA' },
  { to: '/vietnamese-speaking-realtor-orange-county', label: 'VN Realtor OC' },
  { to: '/multigenerational-homes-vietnamese-families', label: 'Multigen Homes' },
  { to: '/adu-homes-westminster-vietnamese-families', label: 'ADU Homes' },
  { to: '/feng-shui-homes-orange-county', label: 'Feng Shui Homes' },
  { to: '/orange-county', label: 'Orange County' },
  { to: '/los-angeles-county', label: 'Los Angeles County' },
  { to: '/riverside-county', label: 'Riverside County' },
  { to: '/san-bernardino-county', label: 'San Bernardino County' },
  { to: '/ventura-county', label: 'Ventura County' },
  { to: '/san-luis-obispo-county', label: 'San Luis Obispo County' },
  { to: '/san-diego-county', label: 'San Diego County' },
];

const SEOLinks = () => (
  <div style={{ padding: '12px 16px', background: '#111', borderTop: '1px solid #333' }}>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 12px', justifyContent: 'center' }}>
      {links.map(({ to, label }) => (
        <Link key={to} to={to} style={{ fontSize: '10px', color: '#999', textDecoration: 'none' }}>
          {label}
        </Link>
      ))}
    </div>
  </div>
);

export default SEOLinks;
